import { useQuery } from '@tanstack/react-query'

import type { UseQueryResult, UseQueryOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { initLoggedInData } from '@src/lib/api/auth/initLoggedInData'

import type { InitLoggedInDataResponse } from '@src/lib/api/auth/initLoggedInData'
import type { InitLoggedInDataPayLoad } from '@src/lib/api/auth/types'
import type { ErrorResponse } from '@src/interface/api/response.interface'

const useInitLoggedInDataQuery = (
	payload: InitLoggedInDataPayLoad,
	options: UseQueryOptions<
		InitLoggedInDataResponse,
		AxiosError<ErrorResponse>,
		InitLoggedInDataResponse
	> = {},
): UseQueryResult<InitLoggedInDataResponse, AxiosError<ErrorResponse>> => {
	return useQuery<InitLoggedInDataResponse, AxiosError<ErrorResponse>>(
		createKey(payload.no),
		async () => initLoggedInData(payload),

		{
			...options,
		},
	)
}

const createKey = (no: string) => ['initLoggedInData', no]
useInitLoggedInDataQuery.createKey = createKey

export default useInitLoggedInDataQuery
